import React from 'react';
import { ButtonLink, PageHero } from '../components/page';

const NotFoundPage = () => (
  <PageHero eyebrow="404" title="Page not found" description="The page you're looking for doesn't exist or has moved.">
    <ButtonLink to="/">Back to home</ButtonLink>
  </PageHero>
);

export default NotFoundPage;
